// extracted by mini-css-extract-plugin
export default {"root":"CustomTablePagination_root__TyD51","keywords":"CustomTablePagination_keywords__dfOWD"};